window.__assetPrefix__ = 'https://dzpiytnygtdr.cloudfront.net/vercel-frontend-ats';